var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7275 11.4659C10.1356 11.4659 8.77289 10.9141 7.6393 9.81031C6.50572 8.70656 5.93892 7.3797 5.93892 5.82974C5.93892 4.27979 6.50572 2.95293 7.6393 1.84918C8.77289 0.745421 10.1356 0.193542 11.7275 0.193542C13.3193 0.193542 14.682 0.745421 15.8156 1.84918C16.9492 2.95293 17.516 4.27979 17.516 5.82974C17.516 7.3797 16.9492 8.70656 15.8156 9.81031C14.682 10.9141 13.3193 11.4659 11.7275 11.4659ZM0.150391 19.9202V18.793C0.150391 17.9945 0.361672 17.2609 0.784235 16.5921C1.2068 15.9232 1.76732 15.4122 2.4658 15.059C3.96117 14.331 5.48066 13.7852 7.02427 13.4217C8.56788 13.0582 10.1356 12.8759 11.7275 12.875C13.3193 12.8741 14.887 13.0563 16.4306 13.4217C17.9742 13.7871 19.4937 14.3329 20.9891 15.059C21.6885 15.4113 22.2496 15.9223 22.6721 16.5921C23.0947 17.2618 23.3055 17.9955 23.3045 18.793V19.9202C23.3045 20.6952 23.0214 21.3589 22.455 21.9112C21.8887 22.4636 21.2071 22.7393 20.4102 22.7384H3.04466C2.24873 22.7384 1.56762 22.4626 1.0013 21.9112C0.434993 21.3598 0.151355 20.6962 0.150391 19.9202Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriend);
export default __webpack_public_path__ + "static/media/friend.c08e738b6a72493e1159f4d453937753.svg";
export { ForwardRef as ReactComponent };